<template>
	<div data-align="center" class="quote-game-cont stack-vertical" data-justify="center">
		<canvas id="quote-game-canvas"></canvas>
		<div v-if="seeCompleted" class="game-modal-completed abs-fill-cover">
			<base-button-rounded v-if="!isMobile" class="exit-completed-button" color="var(--color-white)" :icon="'e-remove-3'" @button-clicked="() => seeCompleted = false"/>
			<div class="game-completed stack-vertical small-radius" data-align="center">
				<div class="stack-horizontal full-width" data-justify="spaced">
					<base-icon v-if="isMobile" name="e-remove-1" @click="() => seeCompleted = false"/>
					<p v-if="!showOnlyIntro" :class="`${isMobile ? 'font-medium' : 'font-titoletti'} capitalize-first`">{{$t('game_citazioni_completate')}}</p>
					<p v-if="isMobile">{{numQuotesCompleted+'/'+gameContents.length}}</p>
				</div>
				<p v-if="!isMobile">{{numQuotesCompleted+'/'+gameContents.length}}</p>
				<div v-masonry transition-duration="0s" item-selector=".quotes-box" class="quotes-box-cont">
					<div v-masonry-tile :class="`quotes-box ${quote.resolved ? 'resolved' : ''}`" v-for="quote in fullQuotes">
						<div class="quotes-box-item">
							<h3 v-if="!isMobile">{{quote.resolved ? quote.quote : completeQuoteText[$i18n.locale]}}</h3>
							<div v-else class="stack-vertical">
								<p class="font-medium" style="line-height: 120%;">{{quote.resolved ? quoteAndAuthor(quote.quote).quote : completeQuoteText[$i18n.locale]}}</p>
								<p v-if="quote.resolved" class="quote-author-mobile capitalize-first">{{quoteAndAuthor(quote.quote).author}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="capitalize-first pointer game-subtitle"
			:style="`text-decoration: underline; visibility: ${showOnlyIntro ? 'hidden' : 'visible'}`"
			@click="() => seeCompleted = true"
		>
			{{$t('game_citazioni_completate')}}
		</div>
		<div v-if="showOnlyIntro" class="quote-game-board-cont stack-vertical" data-align="center">
			<div class="quote-game-board game-intro-section stack-vertical small-radius relative">
				<div class="description" v-html="utils.markdownToHtml($t('game_descrizione_magnetiche'))" />
				<div class="sentences-container" style="margin-top: 1.25rem;">
					<p class="quote-sentence quote-intro">Caron Dimonio</p>
					<p class="quote-sentence quote-intro">con occhi</p>
					<p class="quote-sentence quote-intro">di bragia</p>
				</div>
			</div>
			<base-button v-if="showOnlyIntro" type="variant4" :fit-width="isMobile" :text="utils.capitalizeFirst($t('game_inizia'))" @clicked="() => showOnlyIntro = false"/>
		</div>
		<div v-else-if="!isMobile" class="quote-game-board-cont stack-vertical" data-align="center">
			<div class="quote-game-board stack-vertical small-rounded relative">
				<div :class="`game-result-modal abs-fill stack-vertical small-rounded ${showResultModal ? 'visible' : ''}`" data-justify="center" data-align="center">
					<div class="stack-horizontal result-parenthesis pointer" data-align="center">
						<base-icon name="left-parenthesis"/>
						<div class="section-button-text stack-vertical" data-align="center">
							<h3 class="capitalize-first">{{result}}</h3>
						</div>
						<base-icon name="right-parenthesis"/>
					</div>
				</div>
				<div :class="`game-quote-modal abs-fill stack-vertical small-rounded ${showCreatedQuote ? 'visible' : ''}`">
					<div class="stack-vertical full-height" data-justify="spaced" data-align="start">
						<p class="font-quote font-medium">«{{myQuoteSentence}}»</p>
						<p class="capitalize-first">{{guessedQuoteOwner}}</p>
					</div>
				</div>
				<div class="my-quote-cont">
					<p v-for="sentence in myQuote" class="quote-built quote-sentence">{{sentence.sentence}}</p>
				</div>
				<div class="quote-game-functions stack-horizontal" data-justify="spaced" data-align="center">
					<p>{{`${myQuoteLength}/${maxQuoteLength}`}}</p>
					<div class="quote-game-buttons stack-horizontal">
						<button><base-icon name="refresh-11" @click="emptyMyQuote" /></button>
						<button><base-icon name="erase" @click="deleteLastWord"/></button>
					</div>
				</div>
				<div class="sentences-container">
					<p class="quote-sentence pointer" v-for="sentence in sentencesShuffled" @click="chooseWord($event, sentence)">{{sentence.sentence}}</p>
				</div>
			</div>
			<base-button v-if="!showResultModal && !showCreatedQuote" type="variant4" :text="utils.capitalizeFirst(sendButtonText[$i18n.locale])" @clicked="checkComposition"/>
			<base-button v-if="showResultModal" text="" style="opacity: 0; pointer-events: none;"/>
			<div v-if="showCreatedQuote" class="stack-horizontal" data-align="center" data-justify="center">
				<base-button type="variant4" :text="utils.capitalizeFirst(shareButtonText[$i18n.locale])" @clicked="downloadQuote"/>
				<base-button type="variant4" :text="utils.capitalizeFirst(nextButtontext[$i18n.locale])" @clicked="resetGame"/>
			</div>
		</div>
		<!-- MOBILE VERSION -->
		<div v-else-if="isMobile" class="quote-game-board-cont stack-vertical" data-align="center">
			<div class="quote-game-board stack-vertical small-rounded relative">
				<!-- game result modal -->
				<div :class="`game-result-modal abs-fill stack-vertical small-rounded ${showResultModal ? 'visible' : ''}`" data-justify="center" data-align="center">
					<div class="stack-horizontal result-parenthesis pointer" data-align="center">
						<base-icon name="left-parenthesis"/>
						<div class="section-button-text stack-vertical" data-align="center">
							<h3 class="capitalize-first">{{result}}</h3>
						</div>
						<base-icon name="right-parenthesis"/>
					</div>
				</div>
				<!-- quote written modal -->
				<div :class="`game-quote-modal abs-fill stack-vertical small-rounded ${showCreatedQuote ? 'visible' : ''}`">
					<div class="stack-vertical full-height" data-justify="spaced" data-align="start">
						<p class="font-quote font-medium">«{{myQuoteSentence}}»</p>
						<p class="capitalize-first">{{guessedQuoteOwner}}</p>
					</div>
				</div>
				<div class="quote-game-main-game stack-vertical" data-justify="spaced">
					<div class="my-quote-cont">
						<p v-for="sentence in myQuote" class="quote-built quote-sentence">{{sentence.sentence}}</p>
					</div>
					<div class="quote-game-functions stack-horizontal" data-justify="spaced" data-align="center">
						<p>{{`${myQuoteLength}/${maxQuoteLength}`}}</p>
						<div class="quote-game-buttons stack-horizontal">
							<button><base-icon name="refresh-11" @click="emptyMyQuote" /></button>
							<button><base-icon name="erase" @click="deleteLastWord"/></button>
						</div>
					</div>
				</div>
			</div>
			<div class="quote-mobile-main-buttons">
				<div class="quote-normal-buttons stack-horizontal" v-if="!showCreatedQuote">
					<base-button type="variant4" fit-width :text="utils.capitalizeFirst(chooseWordButtonText[$i18n.locale])" @clicked="openSentencesList"/>
					<base-button type="variant4" fit-width :text="utils.capitalizeFirst(sendButtonText[$i18n.locale])" @clicked="checkComposition"/>
				</div>
				<div v-else class="quote-end-buttons stack-horizontal">
					<base-button type="variant4" fit-width :text="utils.capitalizeFirst(shareButtonText[$i18n.locale])" @clicked="downloadQuote" />
					<base-button type="variant4" fit-width :text="utils.capitalizeFirst(nextButtontext[$i18n.locale])" @clicked="resetGame"/>
				</div>
			</div>
		</div>
		<div v-if="mobileSentencesListOpen" class="quote-mobile-sentences-list-cont stack-vertical" align-items="start">
			<div class="quote-mobile-sentences-list small-rounded stack-vertical">
				<div class="stack-horizontal" data-align="center" data-justify="spaced">
					<p class="capitalize-first" style="text-decoration: underline;" @click="closeSentencesList()">{{$t('generic_chiudi')}}</p>
					<p class="capitalize-first" style="text-decoration: underline;" @click="confirmChoice()">{{$t('generic_inserisci')}}</p>
				</div>
				<div class="sentences-container">
					<p :class="`quote-sentence pointer ${myTempQuote || myQuote ? alreadyChosen(sentence.id) : ''}`" v-for="sentence in sentencesShuffled" @click="chooseTempWord($event, sentence)">{{sentence.sentence}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	
import cloneDeep from 'lodash.clonedeep';
import remove from 'lodash.remove';
import shuffle from 'lodash.shuffle';
import { documentToSVG, elementToSVG, inlineResources, formatXML } from 'dom-to-svg';
import utils from '@js/utils.js'
import { nextTick } from 'vue';
import { mapGetters } from 'vuex';

export default {
	name: 'InterfaceQuoteGame',
	props: {
		gameContents: {
			type: Array,
			default: []
		},
		title: {
			type: String,
		},
		description:{
			type: String,
		}
	},
	data() {
		return {
			myQuote: [],
			myTempQuote: [],
			maxQuoteLength: 10,
			utils,
			result: '',
			showResultModal: false,
			showCreatedQuote: false,
			seeCompleted: false,
			showOnlyIntro: true,
			mobileSentencesListOpen: false,
			showDescription: false,
			introButtonText: {
				it: 'inizia',
				en: 'start'
			},
			nextButtontext: {
				it: "prossima",
				en: "next",
			},
			sendButtonText: {
				it: "invia",
				en: "send"
			},
			shareButtonText: {
		 		it: "condividi",
				en: "share"
			},
			chooseWordButtonText: {
				it: "scegli parola",
				en: "choose word"
			},
			guessedQuoteOwner: '',
			completeQuoteText: {
				it: 'completa la citazione',
				en: 'complete the quote'
			},
			builded: false
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		sentences() {
			let rtn = []
			
			if(!this.builded) return []

			this.gameContents.forEach((el, i) => {
				let keys = Object.keys(el).filter(k => k.startsWith('index'));
				let words = keys.map(k => { return {id: (k+'_'+el.id),index: k, quoteIndex: el.id, sentence: el[k]}})
				rtn = rtn.concat(words)
			})

			rtn = rtn.filter(el => el.sentence.length > 0)

			return rtn;
		},
		myQuoteLength() {
			return this.myQuote.length
		},
		myQuoteSentence() {
			// console.log('my quote', cloneDeep(this.myQuote))
			return this.myQuote.length ? this.myQuote.map(el => el.sentence).join(' ') : ''
		},
		sentencesShuffled() {
			return shuffle(this.sentences)
		},
		fullQuotes() {
			return this.gameContents.map(el => {
				return {
					id: el.id,
					resolved: el.resolved,
					quote: el.quote
				}
			})
		},
		numQuotesCompleted() {
			return this.gameContents.filter(el => el.resolved).length
		},
	},
	watch: {
		async showOnlyIntro(n, o) {
			if(!n && o) {
				await nextTick();

				this.addResultAnimationListener();
				document.querySelector('.result-parenthesis .section-button-text').style.width = 0
			}
		}
	},
	methods: {
		chooseWord(e, sentence) {
			e.preventDefault();
			if(this.myQuote.find(s => s.id == sentence.id)) {
				remove(this.myQuote, el => el.id == sentence.id)
			}else {
				this.myQuote.push(this.sentences.find(s => s.id == sentence.id))
			}
		},
		confirmChoice() {
			this.myQuote = cloneDeep(this.myTempQuote);
			this.closeSentencesList()
		},
		chooseTempWord(e, sentence) {
			e.preventDefault();
			// if(this.myTempQuote.find(s => s.id == sentence.id) ) {
			// 	remove(this.myTempQuote, el => el.id == sentence.id)
			// }
			if(this.myQuote.find(s => s.id == sentence.id) || this.myTempQuote.find(s => s.id == sentence.id)) {
				remove(this.myQuote, el => el.id == sentence.id)
				remove(this.myTempQuote, el => el.id == sentence.id)
				return
			}
			if(!this.myTempQuote.find(s => s.id == sentence.id) && !this.myQuote.find(s => s.id == sentence.id)){
				this.myTempQuote.push(this.sentences.find(s => s.id == sentence.id))
				return
			}
		},
		deleteLastWord() {
			this.myTempQuote.splice(this.myTempQuote.length-1, 1);
			this.myQuote.splice(this.myQuote.length-1, 1);
		},
		emptyMyQuote() {
			this.myTempQuote = []
			this.myQuote = []
		},
		checkComposition() {
			if(!this.myQuote.length) return

			let {res, quoteData} = this.checkQuote();
			this.showResultModal = true;
			this.result = this.$t(res ? "game_corretto" : 'game_sbagliato');
			if(res) {
				this.gameContents.find(el => el.id == quoteData[0].numQuote).resolved = true;
				let quote = this.gameContents.find(el => el.id == quoteData[0].numQuote).quote
				this.guessedQuoteOwner = quote.slice(quote.indexOf('(')).replace('(', '').replace(')', '')
			}else {
				this.guessedQuoteOwner = ''
			}

			let t = utils.createTimeline(1, {});
			nextTick(() => {
				let width = document.querySelector('.result-parenthesis h3').getBoundingClientRect().width;
				this.$el.querySelector('.game-result-modal').style.zIndex = 2;
				t.to('.result-parenthesis .section-button-text', {width: width+'px'}, 0.5);
				t.play();
				setTimeout(() => {
					this.showResultModal = false
					this.showCreatedQuoteModal();
				}, 3000)
			})
		},
		showCreatedQuoteModal() {
			this.showCreatedQuote = true
			this.$el.querySelector('.game-quote-modal').style.zIndex = 2;
		},
		checkQuote() {
			let rtn = true;
			// let [numQuote, indexSentence] = this.myQuote.map(el => el.id).replace('index_', '').splice('_')
			let quoteData = this.myQuote.map(el => {
				return {
					id: el.id,
					indexSentence: el.id.replace('index_', '').split('_')[0],
					numQuote: el.quoteIndex
				}
			})

			let quoteLength = this.sentences.filter(el => el.quoteIndex == quoteData[0].numQuote).length

			if(quoteData.filter(el => el.numQuote == quoteData[0].numQuote).length == quoteLength) {
				quoteData.forEach((el, i) => {
					if(el.id != `index_${i+1}_${el.numQuote}`) {
						rtn = false
					}
				})
			}else {
				// console.log('something wrong', cloneDeep(quoteData.map(el => el.id)))
				rtn = false
			}
			// console.log('quoteData', cloneDeep(quoteData))
			return {res: rtn, quoteData: quoteData}
		},
		openSentencesList() {
			this.mobileSentencesListOpen = true
		},
		closeSentencesList() {
			this.mobileSentencesListOpen = false
			this.myTempQuote = cloneDeep(this.myQuote);
		},
		chooseWordMobile(e, sentence) {
			this.mobileSentencesListOpen = false
			this.chooseWord(e, sentence)
		},
		exitGame() {
			this.resetGame();
			this.$emit('exit')
		},
		quoteAndAuthor(quote) {
			// console.log('quote', quote)
			return {
				quote: quote.slice(0, quote.indexOf('(')),
				author: quote.slice(quote.indexOf('(')).replace('(', '').replace(')', '')
			}
		},
		addResultAnimationListener() {
			let me = this;
			this.$el.querySelector('.game-result-modal').addEventListener('transitionend', function(e) {
				if(e.propertyName == 'opacity' && !me.showResultModal) {
					this.style.zIndex = -2
					document.querySelector('.result-parenthesis .section-button-text').style.width = 0
				}
			})
			this.$el.querySelector('.game-quote-modal').addEventListener('transitionend', function(e) {
				if(e.propertyName == 'opacity' && !me.showCreatedQuote) {
					this.style.zIndex = -2
					// document.querySelector('.result-parenthesis .section-button-text').style.width = 0
				}
			})
		},
		setGameContents() {
			this.gameContents.forEach((g, i) => {
				this.gameContents[i].resolved = false;
				this.gameContents[i].id = i
			})

			this.builded = true
		},
		resetGame() {
			this.myQuote = []
			this.myTempQuote = []
			// this.$el.querySelector('.game-result-modal').style.zIndex = -2;
			// this.$el.querySelector('.game-quote-modal').style.zIndex = -2;
			this.showResultModal = false
			this.showCreatedQuote = false
			this.seeCompleted = false
			this.showOnlyIntro = false
		},
		async downloadQuote() {
			await utils.domToImage(document.querySelector('.game-quote-modal'))

			return

			// let svgDocument = documentToSVG(document) 

			// Capture specific element
			let svgDocument = elementToSVG(document.querySelector('.game-quote-modal'))

			// Inline external resources (fonts, images, etc) as data: URIs
			await inlineResources(svgDocument.documentElement)
			await inlineResources(document.documentElement)
			await inlineResources(document.body)

			// Get SVG string
			// let svgString = new XMLSerializer().serializeToString(svgDocument)

			let svgElements = svgDocument.getElementsByTagName('svg');

			let finalSVG = svgElements[0];

			finalSVG.style.fontFamily = 'Laica'

			let svgString = finalSVG.outerHTML

			// console.log('svg string', svgString, svgDocument, svgElements[0])

			this.svgToPng(svgDocument)

			// Step 4: Append the SVG element to the document or a container
			// document.body.appendChild(svgElement);
			// if(this.isMobile && navigator.canShare) {
			// 	navigator.share({
			// 		title: 'MULTI - my quote.png',
			// 		files: [res],
			// 	})
			// 	.then(() => {
			// 		console.log('Share was successful.')
			// 	})
			// 	.catch((error) => console.log('Sharing failed', error));
			// }
		},
		svgToPng(XMLsvg) {
			function convertSvgToPng(svgElement, canvasElement) {
			  // Get the SVG XML markup
			  var svgXml = new XMLSerializer().serializeToString(XMLsvg);

			  // Create a new Image object
			  var image = new Image();
			  
			  // When the image loads, draw it onto the canvas
			  image.onload = function() {
			    var canvas = canvasElement.getContext("2d");
			    canvas.drawImage(image, 0, 0);
			    
			    // Save the canvas as a PNG image
			    var pngDataUrl = canvasElement.toDataURL("image/png");
			    downloadImage(pngDataUrl);
			  };
			  
			  // Set the SVG XML as the source of the image
			  image.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgXml);
			}

			function downloadImage(dataUrl) {
			  // Create a temporary link element
			  var link = document.createElement("a");
			  link.href = dataUrl;
			  link.download = "image.png";
			  
			  // Programmatically click the link to trigger the download
			  link.click();

			  link.remove()
			}

			// Usage
			// var svgElement = document.getElementById("mySvg");
			var canvasElement = document.getElementById("quote-game-canvas");
			convertSvgToPng(XMLsvg, canvasElement);
		},
		alreadyChosen(sentenceId) {
			let rtn =  
				(
					this.myTempQuote.map(el => el.id).indexOf(sentenceId) > -1 || 
					this.myQuote.map(el => el.id).indexOf(sentenceId) > -1 ? 
					'chosen' : ''
				)
			return rtn
		}
	},
	mounted() {
		this.setGameContents();
		// this.gameContents = shuffle(this.gameContents)
	}
}

</script>

<style lang="scss">

	@import "@css/variables.scss";

	@import '@css/views/ViewScrolly.scss';

	.quote-game-cont {
		flex: 1 0 auto;
		gap: 2rem;
		// color: var(--color-white);

		.sentences-container,
		.my-quote-cont {
			display: flex;
	    flex-wrap: wrap;
	    gap: var(--s0);
		}
	}

	.quote-game-board.game-intro-section {
		// width: max(60vw, 60vh);
		// height: 40vh;
		width: var(--max-game-width);
		color: var(--color-gray-text);
		gap: 0;
	}

	// .game-name {
	// 	font-size: 3.75rem;
	// 	color: var(--color-black-text);
	// }

	.quote-game-board-cont {
		// position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
		flex: 1 0 auto;
    gap: 2rem;
		// max-width: max(60vw, 60vh);
		// color: var(--color-black-text);
	}

	.quote-game-board {
    padding: 2.3rem 2.3rem 1.5rem 2.3rem;
    background-color: var(--color-white);
		gap: 1.25rem;
		flex: 1 0 auto;

		.my-quote-cont {
			min-height: 5rem;
			margin-bottom: auto;
		}
	}

	.quote-game-buttons .svg-icon {
		display: flex;
		width: 1.1rem;
		height: 1.1rem;
	}

	.quote-game-buttons {
		gap: 0.6rem;
	}

	.quote-sentence {
		display: inline-block;
		color: var(--color-white);
		white-space: nowrap;
		background-color: var(--color-brand-blue);
		padding: 0.375rem;
		height: fit-content;
	}

	.quote-sentence.quote-intro {
		color: var(--color-gray-text);
		background-color: var(--color-white);
		border: dashed 1px var(--color-gray-text);
	}

	.game-result-modal,
	.game-quote-modal {
		opacity: 0;
		z-index: -1;
		transition-property: opacity;
		transition-duration: .5s;
		background-color: var(--color-white);
	}

	.game-quote-modal {
		background-color: var(--color-brand-blue);
		color: var(--color-white);
		padding: 5.5rem 4.5rem;
		overflow-y: auto; 
	}

	.game-result-modal.visible,
	.game-quote-modal.visible {
		opacity: 1;
	}

	.result-parenthesis h3 {
		color: var(--color-brand-blue);
		font-size: var(--s3);
		display: inline-block;
		padding: 3.25rem;
	}

	.result-parenthesis .section-button-text {
		opacity: 1;
	}

	.result-parenthesis .svg-icon {
		--svg-icon-color: var(--color-brand-blue);
		width: 1.3rem;
		height: fit-content;
	}

	.game-modal-completed {
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		z-index: 1;
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 3;
	}

	.game-completed {
		padding: var(--s4);
		width: 80%;
		height: 80%;
		overflow-y: scroll;
		gap: var(--s1);
		background-color: var(--color-white);
	}

	.exit-completed-button {
		position: absolute;
		right: var(--s2);
		top: calc(var(--total-bar-height) + var(--s2));
	}

	.quotes-box-cont {
		--grid-gap-game: 1.625rem;
		--num-row-items-game: 4;
		width: calc(100% + var(--grid-gap-game));
		left: calc(var(--grid-gap-game) / 2);
		// gap: 1.625rem;
		// grid-template-columns: repeat(auto-fill, 23%);

	}

	.quotes-box {
		margin-top: var(--grid-gap-game);
		width: calc((100% / var(--num-row-items-game)));
	}

	.quotes-box-item {
				background-color: var(--color-light-gray);
		border: 1px dashed var(--color-dark-gray);
		color: var(--color-dark-gray);
		word-break: break-word;
		padding: 1.438rem;
		width: calc(100% - var(--grid-gap-game));
	}

	.quotes-box.resolved .quotes-box-item {
		border: 0px;
		background-color: var(--color-brand-blue);
		color: var(--color-white);
	}

	#quote-game-canvas {
		position: absolute;
		z-index: -1;
		width: 100vw;
		height: 100vh;
	}

	@media (max-width: $breakpoint-ml) {
		.quote-game-board-cont {
			gap: 1rem;
		}

		.quote-game-cont {
			gap: 1rem;
		}
	}

	@media (max-width: $breakpoint-sm) {

		.quote-game-cont {
			--max-width-quote-game: calc(100vw - 2.5rem);
			--max-height-quote-game: calc(100vh - 2.5rem - var(--menu-size));
			gap: 0.75rem;
		}

		.quote-game-board-cont {
			gap: var(--s1);

			.description strong {
				font-weight: medium;
			}
		}

		.quote-game-board.game-intro-section {
			padding: 0.75rem;
			min-height: 55vh;
		}

		.quote-game-board {
			width: var(--max-game-width);
			padding: 0.75rem;
			min-height: 45vh;
		}

		.quote-game-buttons-cont {
			align-items: center;
			gap: var(--s2);
		}

		.quote-game-buttons-cont h3 {
			font-size: 1.2rem;
		}

		.quote-game-buttons-cont .svg-icon {
			width: var(--s2);
			height: var(--s2);
		}

		.quote-game-main-game {
			height: 100%
		}

		.quote-mobile-main-buttons {
			width: var(--max-width-quote-game);
		}

		.quote-mobile-main-buttons .button-base {
			min-width: unset;
		}

		.quote-mobile-sentences-list-cont {
			position: absolute;
			width: var(--max-width-quote-game);
			height: calc(100vh - var(--menu-size) * 1.25);
			// margin-top: var(--menu-size);
			top: 0;
			gap: 0;
		}

		.quote-mobile-sentences-list {
			background: var(--color-white);
			padding: 1.25rem;
			margin-top: 1.25rem;
			height: 100%;
			overflow-y: auto;
		}

		.quote-sentence.chosen {
			background-color: var(--color-rose);
			color: var(--color-black-text);
		}

		.game-quote-modal {
			padding: 1.25rem;
		}

		.game-completed {
			width: var(--max-width-quote-game);
			height: var(--max-height-quote-game);
			padding: 1.25rem;
		}

		.quote-box p {
			font-family: 'Laica';
		}

		.quotes-box-cont {
			--grid-gap-game: 1.625rem;
			--num-row-items-game: 2;
		}

		.quotes-box-item {
			padding: 0.9rem;
		}

		.quote-author-mobile {
			font-size: 0.75rem;
		}

		.game-info-button-mobile {
			width: 2rem;
			height: 2rem;
		}

		.game-info-button-mobile .svg-icon {
			width: 1rem;
			height: 1rem;
			display: flex;
		}

		.game-description-mobile {
			position: absolute;
			width: calc(87vw - 2.5rem);
			top: 0;
			z-index: 5;
			background-color: var(--color-white);
			padding: 1rem;
		}
	}

</style>
